import React from 'react';
import NiceModal, {useModal} from "@ebay/nice-modal-react";
import AdministrativeForm, {
    AdministrativeFormProps
} from "../../../pages/program/administrative/components/AdministrativeForm";
import {modalClose} from "../genericFunctions";
import SlideOver, {SlideOverProps} from "../../generic/SlideOver";


interface OwnProps extends SlideOverProps, AdministrativeFormProps {
}

type Props = OwnProps;

// @ts-ignore
const AdministrativeModal = NiceModal.create<Props>(({administrative, header, onClose}) => {
    const modal = useModal()

    const handleClose = (e) => {
        modalClose(e, modal, onClose)
    }

    return (
        <SlideOver onClose={handleClose} open={modal.visible} afterClose={modal.remove} title={header}>
            <AdministrativeForm administrative={administrative}/>
        </SlideOver>
    )
})

export default AdministrativeModal;
